// extracted by mini-css-extract-plugin
module.exports = {"badges":"BadgesByDevice-module--badges--2Vi0E"};